export const STEPS = [
  { key: 'package', label: 'Package' },
  { key: 'personal', label: 'Personal' },
  { key: 'contact', label: 'Contact' },
  { key: 'membership', label: 'Membership details' },
  { key: 'health', label: 'Health' },
  { key: 'parq', label: 'PAR-Q' },
  { key: 'agreement', label: 'Agreement' },
  { key: 'payment', label: 'Payment' },
  { key: 'finish', label: 'Finish' },
  { key: 'review', label: 'Review' },
];

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

export const MEMBERSHIP_TYPE_OPTIONS = [
  // Fallback labels only; the membership options API gives the full label with the place limit.
  { value: 'founding_member', label: 'Founding Member' },
  { value: 'student_founding', label: 'Student Founding Member' },

  { value: 'monthly', label: 'Monthly' },
  { value: 'student_monthly', label: 'Student Monthly' },
  { value: 'three_months', label: '3 Months' },
  { value: 'student_three_months', label: 'Student 3 Months' },
  { value: 'six_months', label: '6 Months' },
  { value: 'student_six_months', label: 'Student 6 Months' },
  { value: 'annual', label: 'Annual' },
  { value: 'student_annual', label: 'Student Annual' },
  { value: 'couple_monthly', label: 'Couple Monthly' },
  { value: 'couple_three_months', label: 'Couple 3 Months' },
  { value: 'couple_six_months', label: 'Couple 6 Months' },
  { value: 'couple_annual', label: 'Couple Annual' },
  { value: 'family_monthly', label: 'Family Monthly' },
  { value: 'family_three_months', label: 'Family 3 Months' },
  { value: 'family_six_months', label: 'Family 6 Months' },
  { value: 'family_annual', label: 'Family Annual' },
];

export const TRAINING_GOAL_OPTIONS = [
  { value: 'weight_loss', label: 'Weight Loss' },
  { value: 'muscle_gain', label: 'Muscle Gain' },
  { value: 'fitness_improvement', label: 'Fitness Improvement' },
  { value: 'athletic_performance', label: 'Athletic Performance' },
  { value: 'rehabilitation', label: 'Rehabilitation' },
  { value: 'self_defense', label: 'Self Defense' },
  { value: 'general_health', label: 'General Health' },
];

export const TRAINING_TIME_OPTIONS = [
  { value: 'morning', label: 'Morning' },
  { value: 'afternoon', label: 'Afternoon' },
  { value: 'evening', label: 'Evening' },
];

export const MEDICAL_CONDITIONS = [
  { key: 'heart', label: 'Heart Condition' },
  { key: 'high_blood_pressure', label: 'High Blood Pressure' },
  { key: 'asthma', label: 'Asthma' },
  { key: 'diabetes', label: 'Diabetes' },
  { key: 'joint_problems', label: 'Joint Problems' },
  { key: 'recent_surgery', label: 'Recent Surgery' },
  { key: 'back_problems', label: 'Back Problems' },
  { key: 'epilepsy', label: 'Epilepsy' },
];

export const PARQ_QUESTIONS = [
  { key: 'heart_condition_from_doctor', label: 'Has your doctor ever said you have a heart condition?' },
  { key: 'chest_pain_during_exercise', label: 'Do you feel chest pain during exercise?' },
  { key: 'loss_of_balance_or_consciousness', label: 'Do you lose balance or consciousness?' },
  { key: 'bone_joint_problems_worsened_by_exercise', label: 'Do you have bone or joint problems worsened by exercise?' },
  { key: 'pregnant', label: 'Are you pregnant?' },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'card', label: 'Card Payment' },
  { value: 'online', label: 'Online Payment' },
  { value: 'qr_payment', label: 'QR Payment' },
];

export const BASE_DOCUMENT_ACK_OPTIONS = [
  { key: 'passport_size_photo', label: 'Passport Size Photo' },
  { key: 'payment_proof', label: 'Payment Proof' },
];

export const NIC_DOCUMENT_ACK = {
  key: 'nic_passport_copy',
  label: 'Copy of NIC / Passport',
};

export const STUDENT_DOCUMENT_ACK_OPTIONS = [
  {
    key: 'student_id',
    label:
      'Valid Student ID (school, university, technical college, vocational institute, or government-recognized institution)',
  },
  {
    key: 'enrollment_proof',
    label: 'Current enrollment letter (if Student ID is not available)',
  },
];

export const MEDICAL_CLEARANCE_ACK = {
  key: 'medical_clearance',
  labelRequired: 'Medical Clearance (required)',
  labelOptional: 'Medical Clearance (optional)',
};

export const ALL_DOCUMENT_ACK_KEYS = [
  NIC_DOCUMENT_ACK.key,
  ...BASE_DOCUMENT_ACK_OPTIONS.map((d) => d.key),
  MEDICAL_CLEARANCE_ACK.key,
  ...STUDENT_DOCUMENT_ACK_OPTIONS.map((d) => d.key),
];

export const STUDENT_ELIGIBILITY_LINES = [
  'Available to full-time school, university, and vocational students up to age 19.',
  'Student Founding membership is available to students aged 13–19 only.',
  'A valid Student ID or official proof of enrollment must be submitted during registration.',
  'Access is limited to designated student training hours determined by TEBA HPU management.',
];

export const STUDENT_FOUNDING_DISABLED_REASON = 'Available to students aged 13–19';
export const STUDENT_COMMITMENT_DISABLED_REASON = 'Available to students up to age 19';
export const ADULT_PACKAGE_DISABLED_REASON = 'Available to members aged 13 and above';

export const STUDENT_TRAINING_HOURS_LINES = [
  'Student members may train only during:',
  '• 6:00 am – 4:00 pm, or',
  '• 10:00 am – 5:00 pm',
];

export const LIABILITY_TEXT = `I understand that participation in physical exercise and training programs involves risk of injury. I voluntarily participate in all activities at my own risk.

I agree to:
• Follow all gym rules and instructor guidelines
• Use equipment responsibly
• Inform trainers about medical conditions
• Accept responsibility for injuries caused by negligence or misuse

I release the gym, trainers, and management from liability for injuries, accidents, or loss of personal belongings during participation.`;

const parseAge = (age) => {
  const n = Number(age);
  return Number.isNaN(n) ? null : n;
};

export const isStudentFoundingPackage = (pkgId) => pkgId === 'student_founding';

export const isStudentPackage = (pkgId) =>
  pkgId === 'student_founding' || (typeof pkgId === 'string' && pkgId.startsWith('student_'));

export const isStudentCommitmentPackage = (pkgId) =>
  isStudentPackage(pkgId) && !isStudentFoundingPackage(pkgId);

export const isAdultPackage = (pkgId) => !isStudentPackage(pkgId);

// Family package: each member is priced by age on the server (18+ adult, under 18 student).
export const FAMILY_ADULT_MIN_AGE = 18;

export const isFamilyPackage = (pkgId) =>
  typeof pkgId === 'string' && pkgId.startsWith('family_');

export const isFamilyChild = (pkgId, age) => {
  const n = parseAge(age);
  return isFamilyPackage(pkgId) && age !== '' && n !== null && n < FAMILY_ADULT_MIN_AGE;
};

export const isStudentFoundingEligible = (age) => {
  const n = parseAge(age);
  return n !== null && n >= 13 && n <= 19;
};

export const isStudentCommitmentEligible = (age) => {
  const n = parseAge(age);
  return n !== null && n >= 1 && n <= 19;
};

export const isAdultPackageEligible = (age) => {
  const n = parseAge(age);
  return n !== null && n >= 13;
};

/** @deprecated Use isStudentFoundingEligible */
export const isStudentEligible = isStudentFoundingEligible;

export const isPackageEligible = (pkgId, age) => {
  if (age === '' || age === undefined || age === null) return true;
  if (isFamilyPackage(pkgId)) return true;
  if (isStudentFoundingPackage(pkgId)) return isStudentFoundingEligible(age);
  if (isStudentCommitmentPackage(pkgId)) return isStudentCommitmentEligible(age);
  if (isAdultPackage(pkgId)) return isAdultPackageEligible(age);
  return true;
};

export const getPackageDisabledReason = (pkgId, age) => {
  if (isPackageEligible(pkgId, age)) return undefined;
  if (isStudentFoundingPackage(pkgId)) return STUDENT_FOUNDING_DISABLED_REASON;
  if (isStudentCommitmentPackage(pkgId)) return STUDENT_COMMITMENT_DISABLED_REASON;
  if (isAdultPackage(pkgId)) return ADULT_PACKAGE_DISABLED_REASON;
  return undefined;
};

export const parqRequiresMedicalClearance = (answers) =>
  Object.values(answers || {}).some((v) => v === 'yes');

export const hasRequiredStudentDocumentAck = (documentsAck) =>
  documentsAck?.student_id === true || documentsAck?.enrollment_proof === true;

export const getRequiredDocumentKeys = (membershipType, parqAnswers, age) => {
  const keys = new Set(BASE_DOCUMENT_ACK_OPTIONS.map((d) => d.key));
  if (!isStudentPackage(membershipType) && !isFamilyChild(membershipType, age)) {
    keys.add(NIC_DOCUMENT_ACK.key);
  }
  if (parqRequiresMedicalClearance(parqAnswers)) {
    keys.add(MEDICAL_CLEARANCE_ACK.key);
  }
  return keys;
};

export const emptyMedicalConditions = () =>
  MEDICAL_CONDITIONS.reduce((acc, { key }) => ({ ...acc, [key]: '' }), {});

export const emptyParqAnswers = () =>
  PARQ_QUESTIONS.reduce((acc, { key }) => ({ ...acc, [key]: '' }), {});

export const emptyDocumentsAck = () =>
  ALL_DOCUMENT_ACK_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {});

export const initialValues = {
  fullName: '',
  dateOfBirth: '',
  age: '',
  gender: '',
  nicPassport: '',
  nationality: '',
  occupation: '',
  address: '',
  mobileNumber: '',
  whatsappNumber: '',
  email: '',
  emergencyContactPerson: '',
  emergencyContactRelationship: '',
  emergencyContactNumber: '',
  membershipType: '',
  trainingGoals: [],
  preferredTrainingTimes: [],
  membershipStartDate: '',
  trainerPreference: '',
  medicalConditions: emptyMedicalConditions(),
  takingMedication: '',
  medicationDetails: '',
  hasInjuries: '',
  injuryDetails: '',
  doctorRecommendations: '',
  parqAnswers: emptyParqAnswers(),
  liabilityAgreed: false,
  paymentMethod: '',
  membershipFee: '',
  registrationFee: '',
  totalAmountPaid: '',
  paymentDate: '',
  receiptNumber: '',
  mediaConsent: '',
  declarationName: '',
  declarationSignature: '',
  declarationDate: new Date().toISOString().slice(0, 10),
  documentsAck: emptyDocumentsAck(),
};

export const labelFor = (options, value) =>
  options.find((o) => o.value === value)?.label || value;

export const labelsForList = (options, values) =>
  (values || []).map((v) => labelFor(options, v)).join(', ');
